import { MenuItemAggregate } from '../../../../../aggregats/menu/menu-item.aggregate';
import {
  actualitesSousMenuItem,
  aideSousMenuItem,
  // tutoVideoSousMenuItem,
  versionSousMenuItem,
} from './sous-menu-items.constantes';

export const aideMenuItem: MenuItemAggregate = new MenuItemAggregate('icon-help-2', 'Aide', [
  aideSousMenuItem,
  // tutoVideoSousMenuItem,
  actualitesSousMenuItem,
  versionSousMenuItem,
]);
